import * as React from 'react';
import styled from 'styled-components';

export const LinearGradient = styled.div`
  width: 100%;
  height: 2px;
  display: flex;
  width: 100%;
  background: linear-gradient(
    90deg,
    #92e3a9 -0.7%,
    #de1f70 29%,
    #231f20 60.67%,
    #0b1c2f 90.06%
  );
`;

const Separator: React.FC = () => {
  return <LinearGradient />;
};

export default Separator;
